export default __webpack_public_path__ + "static/awards-mb-ec-61ffbb08560f0e3b7ea5f938efcb90bf.png";